import type { ScoringCriterionKey } from '../../hooks/shared/offers/offer-management/scoringPreference'
import type { OnboardingStepKey } from '../../config/onboardingRegistry'

/** W trybie guided — tylko ta składowa jakości jest liczona w zarządzaniu ofertami. */
export function onboardingScoringComponentForStep(
  stepKey: OnboardingStepKey,
): ScoringCriterionKey | null {
  switch (stepKey) {
    case 'titles_flow':
      return 'title'
    case 'descriptions_flow':
      return 'description'
    case 'grafikomat_flow':
      return 'images'
    case 'parameters_flow':
      return 'parameters'
    default:
      return null
  }
}

export function isGuidedOfferMgmtScoringStep(stepKey: OnboardingStepKey | null): boolean {
  return Boolean(stepKey && onboardingScoringComponentForStep(stepKey))
}
